/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateGiftCardPaymentIntentMutationVariables = Types.Exact<{
  input: Types.CreateGiftCardPaymentIntentInput;
}>;

export type CreateGiftCardPaymentIntentMutation = {
  readonly __typename?: 'Mutation';
  readonly createGiftCardPaymentIntent: {
    readonly __typename: 'PaymentIntent';
    readonly id: string;
    readonly secret: string;
    readonly orderId: string;
  };
};

export const CreateGiftCardPaymentIntentDocument = gql`
  mutation CreateGiftCardPaymentIntent($input: CreateGiftCardPaymentIntentInput!) {
    createGiftCardPaymentIntent(input: $input) {
      __typename
      id
      secret
      orderId
    }
  }
`;

export function useCreateGiftCardPaymentIntentMutation() {
  return Urql.useMutation<
    CreateGiftCardPaymentIntentMutation,
    CreateGiftCardPaymentIntentMutationVariables
  >(CreateGiftCardPaymentIntentDocument);
}
